import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    control: {
      wrapper: 'm-4 bottom-0 <md:top-a'
    }
  },
  controlsSize: { sm: 'sm', md: 'lg' }
} satisfies VfConfig['video']
